import { ImprovementGroupDto, PerformanceClassDto } from '../../core';
import { SortOptions } from '../../table';
import { FilterItemView } from '../model/filter-item-view.model';
import { PerformerItemView } from '../model/performer-item-view.model';

import { sortRows } from './sort-rows.function';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function filterRows(opts: {
    rows: PerformerItemView[];
    sortOptions: SortOptions;
    currentPerformanceClassFilterItems: Array<
        FilterItemView<PerformanceClassDto>
    >;
    previousPerformanceClassFilterItems: Array<
        FilterItemView<PerformanceClassDto>
    >;
    improvementGroupFilterItems: Array<FilterItemView<ImprovementGroupDto>>;
}) {
    let nextFilteredRows = [...opts.rows];

    const selectedCurrPerf = opts.currentPerformanceClassFilterItems.filter(
        (e) => e.selected,
    );
    const selectedPrevPerf = opts.previousPerformanceClassFilterItems.filter(
        (e) => e.selected,
    );
    const selectedImprovement = opts.improvementGroupFilterItems.filter(
        (e) => e.selected,
    );

    if (
        selectedCurrPerf.length +
            selectedPrevPerf.length +
            selectedImprovement.length ===
        0
    ) {
        return sortRows(nextFilteredRows, opts.sortOptions);
    }

    nextFilteredRows = opts.rows.filter((r) => {
        const matchCurrPref = selectedCurrPerf.some(
            (e) =>
                e.item.scorecardPerformanceClassId ===
                r.performanceClass?.scorecardPerformanceClassId,
        );
        const matchPreviousPref = selectedPrevPerf.some(
            (e) =>
                e.item.scorecardPerformanceClassId ===
                r.previousPerformanceClass?.scorecardPerformanceClassId,
        );
        const matchImprovement = selectedImprovement.some(
            (e) =>
                e.item.scorecardImprovementGroupId ===
                r.improvementGroup?.scorecardImprovementGroupId,
        );

        return (
            (selectedCurrPerf.length === 0 || matchCurrPref) &&
            (selectedPrevPerf.length === 0 || matchPreviousPref) &&
            (selectedImprovement.length === 0 || matchImprovement)
        );
    });

    return sortRows(nextFilteredRows, opts.sortOptions);
}
